/* eslint-disable react/prop-types */
import React from 'react';
import { styled } from '@mui/material/styles';
import chroma from 'chroma-js';
import { Box } from '@mui/material';
const Circle = styled('div')(({ size, color }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: color,
  position: 'absolute',
}));

const Necklace = ({ largeCircleSize, smallCircleSize, color }) => {
  const radius = largeCircleSize / 2;
  const circleRadius = smallCircleSize / 2;

  // Calculate the distance from the center of the large circle to the center of each small circle
  const distanceFromCenter = radius - 2 * circleRadius; // Account for extra space between the circles

  // Calculate the number of small circles that can fit around the large circle with the added distance
  const circumference = 2 * Math.PI * distanceFromCenter;
  const numCircles = Math.floor(circumference / (smallCircleSize + circleRadius)); // Include the radius as extra space between circles

  const circleElements = [];
  for (let i = 0; i < numCircles; i++) {
    const angle = (2 * Math.PI / numCircles) * i;
    const x = radius + distanceFromCenter * Math.cos(angle) - circleRadius;
    const y = radius + distanceFromCenter * Math.sin(angle) - circleRadius;
    // Generate a dynamic color for each circle using chroma-js (e.g., a gradient from the input color)
    const dynamicColor = chroma(color).set('hsl.h', (360 / numCircles) * i).rgb().join(',');

    circleElements.push(
      <Circle
        key={i}
        size={smallCircleSize}
        color={`rgb(${dynamicColor})`} // Set the color as an RGB string
        style={{ top: y, left: x }}
      />
    );
  }

  return (
    <Box  style={{ position: 'relative', width: largeCircleSize, minHeight: largeCircleSize }}>
      <Circle
        size={largeCircleSize}
        color="transparent"
        style={{ borderRadius: '50%', position: 'absolute' }}
      />
      {circleElements}

      {/* Recursively render smaller concentric Necklace if largeCircleSize is still greater than 0 */}
      {largeCircleSize > 3 * smallCircleSize && smallCircleSize-1>0 && (
        <div style={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)' 
        }}>
          <Necklace
            largeCircleSize={largeCircleSize - 3 * smallCircleSize}
            smallCircleSize={smallCircleSize-1}
            color={color}
          />
        </div>
      )}
    </Box>
  );
};

export default Necklace;
